<!-- HEADER -->
<div style="float:left;">
    <h2 mat-dialog-title><span translate>{{report.Description}}</span></h2>
</div>
<!-- CONTENT -->
<mat-dialog-content>
    <table *ngIf="!this.showRun" style="width:800px;" st-select-row="parameterRow" st-select-mode="single">

        <tr>
            <td>
                <table style="border: 1px solid lightgray;margin-top:10px;">
                    <tr>
                        <td style="padding-left:3px;">
                            <div style="padding-top:5px;">
                                <tyl-form-field label="View">
                                    <mat-select id="Terms" name="Terms" [(ngModel)]="reportParameter.TermId"
                                        (selectionchange)="changeValue()">
                                        <mat-option
                                            *ngFor="let result of reportParameter.Terms|orderBy: 'LongDescription'"
                                            [value]="result.Id">
                                            {{result.LongDescription}}
                                        </mat-option>
                                    </mat-select>
                                </tyl-form-field>
                            </div>
                        </td>
                        <td style="padding-left:3px;">
                            <div style="padding-top:5px;">
                                <tyl-form-field label="From Period" style="min-width:100px; max-width:100px">
                                    <input matInput #FromPeriod id="FromPeriod" name="FromPeriod"
                                        [(ngModel)]="reportParameter.FromPeriod" min='0' [textMask]="numberMask"
                                        style="text-align:right;width:100px;" (change)="changeValue()" />
                                </tyl-form-field>
                            </div>
                        </td>
                        <td style="padding-left:15px;">
                            <div style="padding-top:5px;">
                                <tyl-form-field label="To Period" style="min-width:100px; max-width:100px">
                                    <input matInput #ToPeriod id="ToPeriod" name="ToPeriod"
                                        [(ngModel)]="reportParameter.ToPeriod" min='0' [textMask]="numberMask"
                                        style="text-align:right;width:100px;" (change)="changeValue()" />
                                </tyl-form-field>
                            </div>
                        </td>
                        <td style="padding-left:10px;padding-right:3px;">
                            <button mat-button tyle="color: black;" (click)="refreshGrid()">Update
                                Display
                            </button>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>

    <!-- Angular Material table definition -->
    <div *ngIf="!this.showRun" style="display: flex;flex-direction: column;"
        [ngStyle]="{'overflow': isDataExist ? 'auto' :'hidden' }">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" style="width:100%;">
            <ng-container matColumnDef="SelectAll">
                <th mat-header-cell *matHeaderCellDef>
                    <tyl-checkbox [(checked)]="reportParameter.selectAllReportGridData" id="chkselectAll"
                        name="chkselectAll" (change)="selectAll(reportParameter.selectAllReportGridData)">
                    </tyl-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                    <tyl-checkbox [(checked)]="element.Select" #Select (change)="selectClass()" translate>
                    </tyl-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="Period">
                <th mat-header-cell *matHeaderCellDef> Per </th>
                <td mat-cell *matCellDef="let element">{{element.Period}}</td>
            </ng-container>
            <ng-container matColumnDef="TermCode">
                <th mat-header-cell *matHeaderCellDef> Term </th>
                <td mat-cell *matCellDef="let element">{{element.TermCode}}</td>
            </ng-container>
            <ng-container matColumnDef="SubjectCode">
                <th mat-header-cell *matHeaderCellDef> Subject </th>
                <td mat-cell *matCellDef="let element">{{element.SubjectCode}}</td>
            </ng-container>
            <ng-container matColumnDef="Section">
                <th mat-header-cell *matHeaderCellDef>Sec</th>
                <td mat-cell *matCellDef="let element">{{element.Section}}</td>
            </ng-container>
            <ng-container matColumnDef="AbbreviatedTitle">
                <th mat-header-cell *matHeaderCellDef> Title </th>
                <td mat-cell *matCellDef="let element">{{element.AbbreviatedTitle}}</td>
            </ng-container>
            <ng-container matColumnDef="TeacherName">
                <th mat-header-cell *matHeaderCellDef> Teacher Name</th>
                <td mat-cell *matCellDef="let element">{{element.TeacherName}}</td>
            </ng-container>
            <ng-container matColumnDef="StudentCount">
                <th mat-header-cell *matHeaderCellDef> #Std</th>
                <td mat-cell *matCellDef="let element">{{element.StudentCount}}</td>
            </ng-container>
            <ng-container matColumnDef="DaysGroupDescription">
                <th mat-header-cell *matHeaderCellDef> Days</th>
                <td mat-cell *matCellDef="let element">{{element.DaysGroupDescription}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="gridColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: gridColumns;"></tr>
        </table>
    </div>

    <div *ngIf="this.showRun" style="padding-top:5px; width:100%;">
        <table>
            <tr>
                <td colspan="3">
                    <tyl-form-field label="Report Title" style="width:350px;">
                        <input matInput name="ReportTitle" id="ReportTitle" #ReportTitle
                            [(ngModel)]="reportParameter.ReportTitle" />
                    </tyl-form-field>
                </td>
            </tr>
            <tr>
                <td><strong>Selection &amp; Options:</strong></td>
            </tr>
            <tr style="border: 1px solid gray;">
                <td>
                    <div>
                        <table>
                            <tr>
                                <td></td>
                                <td style="padding-left: 3px; font-weight: bold;">From:</td>
                                <td style="padding-left: 3px; font-weight: bold;">To:</td>
                            </tr>
                            <tr>
                                <!--SELECT ON HISTORY DATES-->

                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.SelectHistoryDates"
                                        id="chkSelectHistoryDates" name="chkSelectHistoryDates">
                                    </tyl-checkbox>
                                    <span>Select on History Dates</span>
                                </td>
                                <td style="vertical-align:middle;width:100px;">
                                    <ng-container style="display:inline;">
                                        <tyl-datepicker id="HistoryFrom" [(value)]="reportParameters.HistoryFrom"
                                            #HistoryFrom>
                                        </tyl-datepicker>
                                    </ng-container>
                                </td>
                                <td style="vertical-align:middle;width:100px;">
                                    <ng-container style="display:inline;">
                                        <tyl-datepicker id="HistoryTo" [(value)]="reportParameters.HistoryTo"
                                            #HistoryTo>
                                        </tyl-datepicker>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <!--SELECT ON RESIDENCY CODES-->

                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.SelectResidencyCodes"
                                        id="SelectResidencyCodes" name="SelectResidencyCodes" #SelectResidencyCodes>
                                    </tyl-checkbox>
                                    <span>Select on Residency Codes</span>
                                </td>
                                <td style="padding-left: 3px;padding-top:5px;">
                                    <!-- ReportParameter.ResidencyCode -->
                                    <tyl-form-field>
                                        <mat-select id="residencyCodeFrom" name="residencyCodeFrom" #ResidencyCodeFrom
                                            [ngModel]="reportParameters.ResidencyCodeFrom"
                                            (ngModelChange)="reportParameters.ResidencyCodeFrom = $event;">
                                            <mat-option *ngFor="let residencyCode of reportParameters.ResidencyCodes"
                                                [value]="residencyCode.Code">
                                                {{residencyCode.CodeDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </tyl-form-field>
                                </td>
                                <td style="padding-left: 3px;padding-top:5px;">
                                    <tyl-form-field>
                                        <mat-select id="ResidencyCodeTo" name="ResidencyCodeTo" #ResidencyCodeTo
                                            [ngModel]="reportParameters.ResidencyCodeTo"
                                            (ngModelChange)="reportParameters.ResidencyCodeTo = $event;">
                                            <mat-option *ngFor="let residencyCode of reportParameters.ResidencyCodes"
                                                [value]="residencyCode.Code">
                                                {{residencyCode.CodeDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </tyl-form-field>
                                </td>
                            </tr>
                            <tr>

                                <!--SELECT ON ENROLLMENT CATEGORY CODES-->

                                <!-- ReportParameter.EnrollmentCategory -->
                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.SelectCategoryCodes"
                                        id="SelectCategoryCodes" name="SelectCategoryCodes" #SelectCategoryCodes>
                                    </tyl-checkbox>
                                    <span>Select on Category Codes</span>
                                </td>
                                <td style="padding-left: 3px;padding-top:5px;">
                                    <tyl-form-field>
                                        <mat-select id="CategoryCodeFrom" name="CategoryCodeFrom" #CategoryCodeFrom
                                            [ngModel]="reportParameters.CategoryCodeFrom"
                                            (ngModelChange)="reportParameters.CategoryCodeFrom = $event;">
                                            <mat-option *ngFor="let categoryCode of reportParameters.CategoryCodes"
                                                [value]="categoryCode.Code">
                                                {{categoryCode.CodeDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </tyl-form-field>
                                </td>
                                <td style="padding-left: 3px;padding-top:5px;">
                                    <tyl-form-field>
                                        <mat-select id="CategoryCodeTo" name="CategoryCodeTo" #CategoryCodeTo
                                            [ngModel]="reportParameters.CategoryCodeTo"
                                            (ngModelChange)="reportParameters.CategoryCodeTo = $event;">
                                            <mat-option *ngFor="let categoryCode of reportParameters.CategoryCodes"
                                                [value]="categoryCode.Code">
                                                {{categoryCode.CodeDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </tyl-form-field>
                                </td>
                            </tr>
                            <tr>

                                <!--SELECT ON GRADE LEVELS -->

                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <!-- ReportParameter.GradeLevels -->
                                    <tyl-checkbox [(checked)]="reportParameters.SelectGradeLevels"
                                        id="SelectGradeLevels" name="SelectGradeLevels" #SelectGradeLevels>
                                    </tyl-checkbox>
                                    <span>Select on Grade Levels</span>
                                </td>
                                <td style="padding-left: 3px;padding-top:5px;">
                                    <tyl-form-field>
                                        <mat-select id="GradeLevelFrom" name="GradeLevelFrom" #GradeLevelFrom
                                            [ngModel]="reportParameters.GradeLevelFrom"
                                            (ngModelChange)="reportParameters.GradeLevelFrom = $event; setGradeLevelRankFrom();">
                                            <mat-option *ngFor="let gradelevel of reportParameters.GradeLevels"
                                                [value]="gradelevel.Code">
                                                {{gradelevel.CodeDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </tyl-form-field>
                                </td>
                                <td style="padding-left: 3px;padding-top:5px;">
                                    <tyl-form-field>
                                        <mat-select id="GradeLevelTo" name="GradeLevelTo" #GradeLevelTo
                                            [ngModel]="reportParameters.GradeLevelTo"
                                            (ngModelChange)="reportParameters.GradeLevelTo = $event; setGradeLevelRankTo();">
                                            <mat-option *ngFor="let gradelevel of reportParameters.GradeLevels"
                                                [value]="gradelevel.Code">
                                                {{gradelevel.CodeDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </tyl-form-field>
                                    <!-- ReportParameter.GradeLevelsRankFrom , ReportParameter.GradeLevelsRankTo -->
                                </td>
                            </tr>
                            <tr style="border: 1px solid gray;">

                                <!-- HISTORY CODES TO TALLY -->

                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <span> History Codes to Tally</span>
                                </td>
                                <td colspan="2" style="width:550px;">
                                    <!--(change)="parameterChanged(parameter, $event, i) [(checked)]="attCode.IsSelected"-->
                                    <div style="display: flex;" [style.flex-direction]="'horizontal'"
                                        [style.flex-wrap]="'wrap'">
                                        <!-- HistoryCodesToTally -->
                                        <tyl-checkbox *ngFor="let attCode of historyCodesToTally; let i = index"
                                            [value]="attCode.TextField" id="cblHistoryCodesToTally_{{i}}"
                                            name="cblHistoryCodesToTally_{{i}}"
                                            (change)="handleCheckboxAll(attCode, $event, historyCodesToTally)"
                                            [(checked)]="attCode.IsSelected">
                                            {{attCode.TextField}}
                                        </tyl-checkbox>
                                    </div>
                                </td>
                            </tr>

                            <tr style="border: 1px solid gray; border-bottom:none;">

                                <!-- SHOW TOTAL HOURS -->

                                <td style="padding-left:5px; padding-top:5px; width:280px; vertical-align: top;">
                                    <span> Show Total Hours</span>
                                </td>
                                <td colspan="2" style="padding-top:5px;">
                                    <!-- [checked]="reportParameters.ShowTotalHours==0" -->

                                    <!-- <mat-radio-group
                                            [(ngModel)]="reportParameters.ShowTotalHours"
                                            name="ShowTotalHours">
                                            <mat-radio-button
                                                id="rbIncludeAllAbsences"
                                                name="rbIncludeAllAbsences"
                                                style="padding-right:5px;"
                                                [value]="showTotalHoursOption.IncludeAllAbsences"
                                                [checked]="reportParameters.ShowTotalHours == showTotalHoursOption.IncludeAllAbsences">
                                                Include all absences on days that have selected codes
                                            </mat-radio-button>
                                            <mat-radio-button
                                                id="rbIncludeSelectedAbsences"
                                                name="rbIncludeSelectedAbsences"
                                                style="padding-right:5px;"
                                                [value]="showTotalHoursOption.IncludeSelectedAbsences"
                                                [checked]="reportParameters.ShowTotalHours == showTotalHoursOption.IncludeSelectedAbsences">
                                                Only include absences that match selected codes
                                            </mat-radio-button>
                                        </mat-radio-group>  -->

                                    <mat-radio-group [(ngModel)]="reportParameters.IncludeAllAbsences"
                                        name="ShowTotalHours">
                                        <mat-radio-button id="rbIncludeAllAbsences" name="rbIncludeAllAbsences"
                                            style="padding-right:5px;" [value]="true">
                                            Include all absences on days that have selected codes
                                        </mat-radio-button>
                                        <mat-radio-button id="rbIncludeSelectedAbsences"
                                            name="rbIncludeSelectedAbsences" style="padding-right:5px;" [value]="false">
                                            Only include absences that match selected codes
                                        </mat-radio-button>
                                    </mat-radio-group>

                                    <!-- ReportParameter.IncludeAbsences -->
                                </td>
                            </tr>

                            <tr style="border-left: 1px solid gray; border-right: 1px solid gray;">

                                <!-- PERIODS TO TALLY -->

                                <td style="vertical-align:top;padding-left:5px; padding-top:5px;  width:280px;">
                                    <span> Periods to Tally</span>
                                </td>
                                <td colspan="2" style="padding-top:5px;">
                                    <div style='white-space: no-wrap; display: flex; align-content: flex-start;'>
                                        <!-- <mat-radio-group
                                                [(ngModel)]="reportParameters.PeriodsToTally"
                                                style="flex-direction: column"
                                                name="PeriodsToTally" >
                                                <mat-radio-button
                                                    id="rbOnlyPeriods"
                                                    name="rbOnlyPeriods"
                                                    style="padding-right:5px;"
                                                    [checked]="reportParameters.PeriodsToTally == periodsToTallyOption.OnlyPeriodsforEachSection"
                                                    [value]="periodsToTallyOption.OnlyPeriodsforEachSection" >
                                                    Only Periods for Each Class‑Section
                                                </mat-radio-button>
                                                <mat-radio-button
                                                    id="rbAllPeriods"
                                                    name="rbOnlyPeriods"
                                                    style="padding-right:5px;"
                                                    [checked]="reportParameters.PeriodsToTally == periodsToTallyOption.AllPeriodsForEachStudent"
                                                    [value]="periodsToTallyOption.AllPeriodsForEachStudent" >
                                                    All Periods for Each Student
                                                </mat-radio-button>
                                            </mat-radio-group> -->
                                        <mat-radio-group [(ngModel)]="reportParameters.OnlyPeriodsforEachSection"
                                            style="flex-direction: column" name="PeriodsToTally">
                                            <mat-radio-button id="rbOnlyPeriods" name="rbOnlyPeriods"
                                                style="padding-right:5px;" [value]="true">
                                                Only Periods for Each Class‑Section
                                            </mat-radio-button>
                                            <mat-radio-button id="rbAllPeriods" name="rbOnlyPeriods"
                                                style="padding-right:5px;" [value]="false">
                                                All Periods for Each Student
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </td>
                            </tr>
                            <tr style="border-left: 1px solid gray; border-right: 1px solid gray;">
                                <td style="vertical-align:top;padding-top:5px;width:280px;">
                                </td>
                                <td colspan="2">
                                    <tyl-checkbox [(checked)]="reportParameters.Count1Day" id="cbCount1Day"
                                        name="cbCount1Day">
                                        Count 1/day
                                    </tyl-checkbox>
                                    <tyl-checkbox [(checked)]="reportParameters.SplitABDays" id="SplitABDays"
                                        name="SplitABDays">
                                        Split A/B Days
                                    </tyl-checkbox>

                                </td>
                            </tr>


                            <tr style="border: 1px solid gray; border-top:none;">

                                <td style="text-align:right;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.HistoryMinMax" id="HistoryMinMax"
                                        name="HistoryMinMax">
                                        <span> Select on Min/Max for above Tally</span>
                                    </tyl-checkbox>
                                </td>
                                <td colspan="2" style="padding-top:5px; padding-left:5px;">
                                    <tyl-form-field style="max-width:100px;text-align: right;">
                                        <input matInput name="HistoryCountMin" mask="999" id="HistoryCountMin"
                                            #HistoryCountMin [(ngModel)]="reportParameters.HistoryCountMin" />
                                    </tyl-form-field>
                                    To
                                    <tyl-form-field style="max-width:100px;text-align: right;">
                                        <input matInput name="HistoryCountMax" mask="999" id="HistoryCountMax"
                                            #HistoryCountMax [(ngModel)]="reportParameters.HistoryCountMax" />
                                    </tyl-form-field>
                                </td>
                            </tr>


                            <tr style="border: 1px solid gray;">

                                <!-- TALLY TARDIES-->

                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.TallyTardies" id="chkTallyTardies"
                                        name="chkTallyTardies">
                                    </tyl-checkbox>
                                    <span> Tally Tardies</span>
                                </td>
                                <td colspan="2">
                                    <div style="display: flex;" [style.flex-direction]="'horizontal'"
                                        [style.flex-wrap]="'wrap'">
                                        <!-- HistoryCodesToTally -->
                                        <tyl-checkbox *ngFor="let attCode of tallyTardiesCodes; let i = index"
                                            [value]="attCode.TextField" id="cblTallyTardiesCodes_{{i}}"
                                            name="cblTallyTardiesCodes_{{i}}"
                                            (change)="handleCheckboxAll(attCode, $event, tallyTardiesCodes)"
                                            [(checked)]="attCode.IsSelected">
                                            {{attCode.TextField}}
                                        </tyl-checkbox>
                                    </div>
                                    <!--(change)="parameterChanged(parameter, $event, i) [(checked)]="dataItem.IsSelected"-->
                                    <!-- <div style="display: flex;" [style.flex-direction]="horizontal"
                                            [style.flex-wrap]="nowrap">
                                            <tyl-checkbox
                                                *ngFor="let attCode of reportParameters.AttendanceCodes; let i = index"
                                                [value]="attCode.Code" id="cblTallyTardies_{{i}}"
                                                name="cblTallyTardies_{{i}}">
                                                {{attCode.CodeDescription}}
                                            </tyl-checkbox>
                                        </div> -->
                                </td>
                            </tr>

                            <tr style="border: 1px solid gray; border-bottom: none;">

                                <!-- DAYS FULL/HALF SELECT CODES -->

                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.DaysFullHalf" id="DaysFullHalf"
                                        name="DaysFullHalf" #DaysFullHalfSelect>
                                    </tyl-checkbox>
                                    <span> Days (Full/Half) Select Codes</span>
                                </td>
                                <td colspan="2">
                                    <!--(change)="parameterChanged(parameter, $event, i) [(checked)]="dataItem.IsSelected"-->
                                    <div style="display: flex;" [style.flex-direction]="'horizontal'"
                                        [style.flex-wrap]="'wrap'">
                                        <tyl-checkbox *ngFor="let attCode of daysCodes; let i = index"
                                            [value]="attCode.TextField" id="cblDaysCodes_{{i}}"
                                            name="cblDaysCodes_{{i}}"
                                            (change)="handleCheckboxAll(attCode, $event, daysCodes)"
                                            [(checked)]="attCode.IsSelected">
                                            {{attCode.TextField}}
                                        </tyl-checkbox>
                                    </div>

                                </td>
                            </tr>
                            <tr style="border: 1px solid gray; border-top: none;">
                                <td style="padding-left:5px;padding-top:5px;width:280px; text-align:right">
                                    <tyl-checkbox [(checked)]="reportParameters.FullDay" id="cbFullDay" name="FullDay">
                                    </tyl-checkbox> FullDay
                                    <tyl-checkbox [(checked)]="reportParameters.HalfDay" id="cbHalfDay" name="HalfDay">
                                    </tyl-checkbox> HalfDay
                                </td>
                                <td colspan="2" style="padding-top:5px; padding-left:5px;">
                                    <tyl-form-field style="max-width:100px;text-align: right;">
                                        <input matInput name="DaysCountMin" mask="999" id="DaysCountMin" #DaysCountMin
                                            [(ngModel)]="reportParameters.DaysCountMin" />
                                    </tyl-form-field>
                                    To
                                    <tyl-form-field style="max-width:100px;text-align: right;">
                                        <input matInput name="DaysCountMax" mask="999" id="DaysCountMax" #DaysCountMax
                                            [(ngModel)]="reportParameters.DaysCountMax" />
                                    </tyl-form-field>
                                </td>
                            </tr>
                            <!--

                                                                            <td style="padding-left:5px;padding-top:5px;padding-bottom:5px;width:280px;text-align:right;">
                                            <input type="checkbox" data-ng-model="ReportParameter.FullDay" /><span> FullDay</span>
                                            <input type="checkbox" data-ng-model="ReportParameter.HalfDay" style="margin-left:10px;" /><span> HalfDay</span>
                                        </td>
                                        <td style="padding-left:3px;padding-top:5px;padding-bottom:5px;">
                                            <input type="text" id="DaysCountMin" ng-model="ReportParameter.DaysCountMin" style="text-align:right;width:48px;margin-right:10px;" mask="9999" />
                                            To
                                            <input type="text" ng-model="ReportParameter.DaysCountMax" style="text-align:right;width:48px;margin-left:10px;" mask="9999" />
                                        </td>
                                -->
                            <tr style="border: 1px solid gray; border-bottom:none; border-top:none;">

                                <!-- TODAY'S CURENT CODES TARDIES-->

                                <td style="padding-left:5px;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.TodaysCurrentTally"
                                        id="cbTodaysCurrentTally" name="TodaysCurrentTally">
                                    </tyl-checkbox>
                                    <span> Today's Current Codes Tally</span>
                                </td>
                                <td colspan="2">
                                    <!--(change)="parameterChanged(parameter, $event, i) [(checked)]="dataItem.IsSelected"-->
                                    <div style="display: flex;" [style.flex-direction]="'horizontal'"
                                        [style.flex-wrap]="'wrap'">
                                        <tyl-checkbox *ngFor="let attCode of todaysCodesToTally; let i = index"
                                            [value]="attCode.TextField" id="cblTodaysCodesToTally_{{i}}"
                                            name="cblTodaysCodesToTally_{{i}}"
                                            (change)="handleCheckboxAll(attCode, $event, todaysCodesToTally)"
                                            [(checked)]="attCode.IsSelected">
                                            {{attCode.TextField}}
                                        </tyl-checkbox>
                                    </div>
                                </td>
                            </tr>
                            <tr style="border: 1px solid gray; border-top:none;">
                                <td style="text-align:right;padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.CurrentMinMax" id="CurrentMinMax"
                                        name="CurrentMinMax">
                                        <span> Select on Min/Max for above Tally</span>
                                    </tyl-checkbox>
                                </td>
                                <td colspan="2" style="padding-top:5px; padding-left:5px;">
                                    <tyl-form-field style="max-width:100px;text-align: right;">
                                        <input matInput name="CurrentCodesTallyCountMin" mask="999"
                                            id="CurrentCodesTallyCountMin" #CurrentCodesTallyCountMin
                                            [(ngModel)]="reportParameters.CurrentCodesTallyCountMin" />
                                    </tyl-form-field>
                                    To
                                    <tyl-form-field style="max-width:100px;text-align: right;">
                                        <input matInput name="CurrentCodesTallyCountMax" mask="999"
                                            id="CurrentCodesTallyCountMax" #CurrentCodesTallyCountMax
                                            [(ngModel)]="reportParameters.CurrentCodesTallyCountMax" />
                                    </tyl-form-field>
                                </td>
                            </tr>
                            <tr style="border: 1px solid gray; border-bottom:none;">

                                <!-- CHECKBOX OPTIONS AT END -->

                                <td style="padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.DoubleSpaceAfterStudentName"
                                        id="cbDoubleSpaceAfterStudentName" name="cbDoubleSpaceAfterStudentName">
                                        Double‑space (after Student Name)
                                    </tyl-checkbox>
                                </td>
                                <td colspan="2" style="padding-top:5px; padding-left:5px;">
                                </td>
                            </tr>
                            <tr style="border-left: 1px solid gray; border-right: 1px solid gray;">
                                <td style="padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.ShowPresentCount"
                                        id="cbShowPresentCount" name="cbShowPresentCount">
                                        Show Present Count
                                    </tyl-checkbox>
                                </td>
                                <td colspan="2" style="padding-top:5px; padding-left:5px;">
                                </td>
                            </tr>
                            <tr style="border-left: 1px solid gray; border-right: 1px solid gray;">
                                <td style="padding-top:5px;width:280px;">
                                    <tyl-checkbox [(checked)]="reportParameters.ShowHistoryRecords"
                                        id="cbShowHistoryRecords" name="cbShowHistoryRecords">
                                        Show History Records
                                    </tyl-checkbox>
                                </td>
                                <td colspan="2" style="padding-top:5px; padding-left:5px;">
                                    <tyl-checkbox [(checked)]="reportParameters.ShowOnlySelectedRecords"
                                        id="cbShowOnlySelectedRecords" name="cbShowOnlySelectedRecords">
                                        Only for Selected Records
                                    </tyl-checkbox>
                                </td>
                            </tr>
                            <tr style="border-left: 1px solid gray; border-right: 1px solid gray;">
                                <td style="padding-top:5px;width:280px; padding-left:30px;">
                                    <tyl-checkbox [(checked)]="reportParameters.ShowComments" id="cbShowComments"
                                        name="cbShowComments">
                                        Show Comments
                                    </tyl-checkbox>
                                </td>
                                <td colspan="2" style="padding-top:5px; padding-left:5px;">

                                </td>
                            </tr>
                            <tr style="border-left: 1px solid gray; border-right: 1px solid gray;">
                                <td colspan="3" style="padding-top:5px;">
                                    <tyl-checkbox [(checked)]="reportParameters.IgnoreAttendance"
                                        id="cbIgnoreAttendance" name="cbIgnoreAttendance">
                                        Ignore Attendance prior to Student's current ReInstate Date
                                    </tyl-checkbox>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>

        </table>
    </div>

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
    <div class="flex-footer-left" style="align-items: center; width: 30%">
    </div>
    <div class="flex-footer-right" style="align-items: center; width: 70%">
        <!-- ERROR PROMPT -->
        <error-prompt [errorList]="errors"></error-prompt>

        <tyl-button *ngIf="showRun" style="float:right; color: black;" image="previous arrow.png" label="Previous"
            (clickEvent)="prevClick()"></tyl-button>
        <tyl-button *ngIf="!showRun" style="float:right; color: black;" image="next arrow.png" label="Next"
            (clickEvent)="nextClick()"></tyl-button>
        <tyl-button *ngIf="showRun" style="float:right; color: black;" image="save.png" label="Run"
            (clickEvent)="runClick()">
        </tyl-button>
        <tyl-button style="float:right; color: black;" image="cancel.png" label="Cancel"
            (clickEvent)="cancelShowReportParameters()"></tyl-button>
    </div>
</mat-dialog-actions>
